// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TCreateTicketingSystemRequestPayload,
  TCreateTicketingSystemResponsePayload,
  TDeleteTicketingSystemRequestPayload,
  TDeleteTicketingSystemResponsePayload,
  TGetTicketingSystemOptionsRequestPayload,
  TGetTicketingSystemOptionsResponsePayload,
  THasCascadeTicketingRequestPayload,
  THasCascadeTicketingResponsePayload,
  TListTicketingSystemsRequestPayload,
  TListTicketingSystemsResponsePayload,
  TUpdateTicketingSystemRequestPayload,
  TUpdateTicketingSystemResponsePayload,
} from './ticketing-integrations.types.ts';

export const createTicketingIntegrationsApi = (transport: TApiTransport) => ({
  /** Registers a ticketing system */
  createTicketingSystem: (
    payload: TCreateTicketingSystemRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TCreateTicketingSystemRequestPayload,
      TCreateTicketingSystemResponsePayload
    >('/create_ticketing_system', payload, options),

  /** Removes a ticketing system */
  deleteTicketingSystem: (
    payload: TDeleteTicketingSystemRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteTicketingSystemRequestPayload,
      TDeleteTicketingSystemResponsePayload
    >('/delete_ticketing_system', payload, options),

  /** Returns a ticketing system's options */
  getTicketingSystemOptions: (
    payload: TGetTicketingSystemOptionsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTicketingSystemOptionsRequestPayload,
      TGetTicketingSystemOptionsResponsePayload
    >('/get_ticketing_system_options', payload, options),

  /** Checks whether the project uses Cascade ticketing */
  hasCascadeTicketing: (
    payload: THasCascadeTicketingRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      THasCascadeTicketingRequestPayload,
      THasCascadeTicketingResponsePayload
    >('/has_cascade_ticketing', payload, options),

  /** Lists ticketing systems */
  listTicketingSystems: (
    payload: TListTicketingSystemsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TListTicketingSystemsRequestPayload,
      TListTicketingSystemsResponsePayload
    >('/list_ticketing_systems', payload, options),

  /** Updates a ticketing system */
  updateTicketingSystem: (
    payload: TUpdateTicketingSystemRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateTicketingSystemRequestPayload,
      TUpdateTicketingSystemResponsePayload
    >('/update_ticketing_system', payload, options),
});
